'use client'

import {usePathname, useRouter} from "next/navigation";
import {useEffect, useState} from "react";
import InnerBanner from "@/components/InnerBanner";
import Button from "@/components/Button";
import {Col, Container, Row} from "react-bootstrap";
import styled from "styled-components";
import Link from "next/link";
import {primary,hover} from "@/styles/globalStyleVars";
import {getSearchApi} from "@/api";
import reactHtmlParser from "react-html-parser";


const Search = () => {
    const [searchInput, setSearchInput] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleInput = (e) => {
        setSearchInput(e.target.value);
    };

    const searchSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        const trimmedInput = searchInput.trim();

        if (!trimmedInput) {
            setError('Please enter a search term.');
            setIsLoading(false);
            return;
        }

        try {
            const results = await getSearchApi(trimmedInput);
            console.log(results);
            setSearchResults(results);
        } catch (err) {
            console.error('Search error:', err);
            setError('Failed to fetch search results.');
        } finally {
            setIsLoading(false);
        }
    };



    return (
        <>
            <StyledSection className={'home-page'}>
                <Container className={'search'}>
                    <Row className={'search-row'}>
                        <Col md={10}>
                            <form onSubmit={searchSubmit}>
                                <div className="search-input">
                                    <input
                                        type="text"
                                        value={searchInput}
                                        onChange={handleInput}
                                        placeholder={'Search'}
                                        className="form-control"
                                    />
                                    <img src="/images/static/search-icon.svg" alt="search-icon" />
                                </div>
                            </form>
                        </Col>
                        <Col md={2}>
                            <Button
                                text={'Search'}
                                padding={'11px 60px 9px 60px'}
                                hoverBackground={hover} // Replace with your color variable or value
                                hovercolor={'#FFF'}
                                background={primary} // Replace with your color variable or value
                                onClick={searchSubmit}
                                hoverborder={`1px solid ${hover}`}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} style={{ marginTop: '60px' }}>
                            {isLoading && <p>Loading...</p>}
                            {error && <p>{error}</p>}
                            {searchResults?.data && searchResults?.data.length > 0 ? (
                                searchResults?.data
                                    .filter((element) => element.search_slug) // Filter out results with empty search_slug
                                    .map((element, index) => (
                                        <div className="search-single" key={index}>
                                            <Link
                                                href={`/${element.search_slug}`}
                                            >
                                                {element.title}
                                            </Link>
                                            {element?.short_desc && <p>{reactHtmlParser(element?.short_desc)}</p>}
                                        </div>
                                    ))
                            ) : (
                                <p>No results found.</p>
                            )}
                        </Col>
                    </Row>
                </Container>
            </StyledSection>
        </>
    );
};

const StyledSection = styled.section`

  .search {
    padding-top: 100px;
    padding-bottom: 100px;
    min-height: 80vh;

    form {
      //height: 100%;
      width: 100%;
      border: 1px solid ${hover};
      border-radius: 50px;
      padding: 0 40px;
      z-index: 1;
      background-color: ${hover};
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      cursor: pointer;

      .search-input {
        display: flex;
        align-items: center;
        justify-content: space-between;
        //height: 100%;

        .form-control {
          width: 100%;
          height: 100%;
          padding: 12px 0 9px 0px;
          font-size: 16px;
          line-height: 24px;
          font-weight: 500;
          color: #ffffff;
          background-color: transparent;
          border: none;
          border-radius: 0;
          transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
          //margin: 0 0 0 30px;
            margin: 0;
          &::placeholder {
            color: rgba(255, 255, 255, 0.6) !important;
          }
        }

        input {

          color: #FFFFFF !important;

          &::placeholder {
            color: #FFFFFF !important;
          }
        }
      }

      .global-image {
        position: absolute;
        height: 18px;
        width: 18px;
        margin: 0px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          inset: 0px;
        }
      }
    }

    .search-single {
      border-bottom: 1px solid rgba(221, 221, 221, 0.7);
      padding: 20px 0;

      a {
        text-transform: capitalize;
          color: ${primary};
          font-size: 24px;
          line-height: 32px;
      }
        p{
            font-size: 16px;
            line-height: 24px;
            opacity: 0.75;
            margin-top: 10px;
        }
    }

    @media (max-width: 767px) {
      //.dc-btn {
      //  margin-top: 30px;
      //}
    }
  }
    
    @media(max-width: 991px){
        .search-row{
            flex-direction: column;
            gap: 30px;
            .col-md-10, .col-md-2{
                flex: 0 0 100%;
                max-width: 100%;
            }
            .dc-btn{
                width: 100%;
                a{
                    width: 100%;
                }
            }
        }
    }
`;

export default Search;
